import {z} from '@hono/zod-openapi';

export const VoiceWebhookEventTypeSchema = z
  .object({type: z.string().min(1).openapi({example: 'realtime.call.incoming'})})
  .passthrough()
  .openapi('VoiceWebhookEventTypeSchema');
